import React, {Fragment, useEffect, useState} from "react";
import AdvancedSearch from "./index";
import {useAdvancedSearchDSMutation} from "../../core/api/ds-state-api";

export default function AdvancedSearchDS() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchDSMutation} />
}